import { hubbleAPI } from './url'
const resource = hubbleAPI + 'secure/public/ct/create-new-subscription'
const resourceChangeSub = hubbleAPI + 'secure/public/ct/change-subscription'
export default ($axios) => ({
  validateNewSubscription(subscriptionSignUpData, cartID) {
    return $axios.post(`${resource}/validate/${cartID}`, subscriptionSignUpData)
  },
  preValidateNewSubscription(subscriptionSignUpData) {
    return $axios.post(`${resource}/prevalidate`, subscriptionSignUpData)
  },
  validateChangeSubscription(subscriptionSignUpData) {
    return $axios.post(`${resourceChangeSub}/validate`, subscriptionSignUpData)
  },
  preValidateChangeSubscription(subscriptionSignUpData) {
    return $axios.post(`${resourceChangeSub}/prevalidate`, subscriptionSignUpData)
  },
  getSubscriptions(accessToken) {
    const url = hubbleAPI + 'secure/public/ct/get-subscriptions';
    return $axios.post(url, accessToken)
  }
})
